import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useDeleteBox = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutateDeleteFn(ENDPOINTS.DELETE_BOX, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([ENDPOINTS.GET_BOX_LIST]);
        queryClient.invalidateQueries([ENDPOINTS.GET_BOXES]);
      },
    }
  );
};
